<footer class="edit-footer">
  <button type="button" mat-button class="cancel" (click)="onClose()">
    {{ cancelText }}
  </button>
  <button *ngIf="excuteText" mat-button class="excute" [disabled]="disabled">
    {{ excuteText }}
  </button>
</footer>
